import { get, post, postExFile } from "@utils/httpUtil";
// 处方单管理-分页查询社区处方单列表
export function getPrescriptionPage(data, config) {
  return post(`/c/pc/communityPrescription/getPrescriptionPage`, data, config);
}
// 处方单管理-查询处方单详情
export function getPrescriptionDetail(data, config) {
  return get(`/c/pc/communityPrescription/getPrescriptionDetail`, data, config);
}
// 服务设置-获取社区快捷处方服务开通状态
export function getCommunityServiceManageConfig(data, config) {
  return post(`/c/pc/communityServiceManage/getCommunityServiceManageConfig`, data, config);
}
// 服务设置-开启、关闭社区快捷处方服务
export function updateCommunityServiceManageConfig(data, config) {
  return post(`/c/pc/communityServiceManage/updateCommunityServiceManageConfig`, data, config);
}
// 服务设置-分页查询快捷处方服务医生列表
export function getCommunityServiceManagePageList(data, config) {
  return post(`/c/pc/communityServiceManage/pageList`, data, config);
}
// 服务设置-查询医生关联模板列表
export function pageTemplateDoctorRelation(data, config) {
  return post(`/c/pc/prescription/template/pageTemplateDoctorRelation`, data, config);
}
// 服务设置-批量开启、关闭医生快捷处方服务
export function batchUpdateDoctorServiceStatus(data, config) {
  return post(`/c/pc/communityServiceManage/batchUpdateDoctorServiceStatus`, data, config);
}
// 服务设置-批量下载医生服务二维码
export function communityServiceManageQrCodeBatchExport(data, config) {
  return postExFile(`/c/pc/qrCode/batchExport`, data, config);
}
// 服务设置-获取医生服务二维码
export function generateQrCode(data, config) {
  return get(`/c/pc/qrCode/generateQrCode`, data, config);
}
// 处方模板-分页查询社区处方模板
export function getTemplatePageList(data, config) {
  return post(`/c/pc/prescription/template/templatePage`, data, config);
}
// 服务设置-编辑并保存医生服务
export function batchDistributeTemplate2Doctor(data, config) {
  return post(`/c/pc/prescription/template/batchDistributeTemplate2Doctor`, data, config);
}
// 服务设置-编辑并保存医生服务
export function prescriptionSaveDoctorTemplate(data, config) {
  return post(`/c/pc/prescription/template/saveDoctorTemplate`, data, config);
}
////////////////////////////////////
// 查询管理后台处方单列表
export function communityPrescriptionGetPrescriptionPage(data, config) {
  return post(`/c/pc/communityPrescription/getPrescriptionPage`, data, config);
}
// 查询管理后台处方单列表-导出
export function communityPrescriptionGetPrescriptionPageExport(data, config) {
  return postExFile(`/c/pc/communityPrescription/getPrescriptionPageExport`, data, config);
}
// 查询处方单详情
export function communityPrescriptionGetPrescriptionDetail(data, config) {
  return get(`/c/pc/communityPrescription/getPrescriptionDetail`, data, config);
}
// 医生管理-医生列表-查询医生展示设置开关
export function communityDoctorGetConfigSetting(data, config) {
  return post(`/c/pc/community/doctor/configSetting/get`, data, config);
}
// 医生管理-医生列表-编辑医生展示设置开关
export function communityDoctorEditConfigSetting(data, config) {
  return post(`/c/pc/community/doctor/configSetting/edit`, data, config);
}
// 服务设置-图文咨询-分页查询社区图文咨询管理列表
export function communityConsultServiceGetPageList(data, config) {
  return post(`/c/pc/communityConsultService/pageList`, data, config);
}
// 服务设置-图文咨询-查询社区图文咨询开关配置
export function communityConsultServiceGetConfig(data, config) {
  return post(`/c/pc/communityConsultService/getConfig`, data, config);
}
// 服务设置-图文咨询-编辑社区图文咨询开关配置
export function communityConsultServiceUpdateConfig(data, config) {
  return post(`/c/pc/communityConsultService/updateConfig`, data, config);
}
// 服务设置-图文咨询-批量更新医生图文咨询显示状态
export function communityConsultServiceBatchUpdateConsultServiceStatus(data, config) {
  return post(`/c/pc/communityConsultService/batchUpdateConsultServiceStatus`, data, config);
}
// 服务设置-图文咨询-图文咨询管理列表-导出
export function communityConsultServiceExport(data, config) {
  return postExFile(`/c/pc/communityConsultService/export`, data, config);
}
// 服务设置-快速开药-分页查询社区快速开药管理列表
export function communityPrescribeConsultServiceGetPageList(data, config) {
  return post(`/c/pc/communityPrescribeConsultService/pageList`, data, config);
}
// 服务设置-快速开药-查询社区快速开药开关配置
export function communityPrescribeConsultServiceGetConfig(data, config) {
  return post(`/c/pc/communityPrescribeConsultService/getConfig`, data, config);
}
// 服务设置-快速开药-编辑社区快速开药开关配置
export function communityPrescribeConsultServiceUpdateConfig(data, config) {
  return post(`/c/pc/communityPrescribeConsultService/updateConfig`, data, config);
}
// 服务设置-快速开药-批量更新医生快速开药显示状态
export function communityPrescribeConsultServiceBatchUpdatePrescribeConsultServiceStatus(data, config) {
  return post(`/c/pc/communityPrescribeConsultService/batchUpdatePrescribeConsultServiceStatus`, data, config);
}
// 服务设置-图文咨询-快速开药管理列表-导出
export function communityPrescribeConsultServiceExport(data, config) {
  return postExFile(`/c/pc/communityPrescribeConsultService/export`, data, config);
}
// 服务设置-快速开药-分页查询社区电话咨询管理列表
export function communityTelConsultServiceGetPageList(data, config) {
  return post(`/c/pc/communityTelConsultService/pageList`, data, config);
}
// 服务设置-快速开药-查询社区电话咨询开关配置
export function communityTelConsultServiceGetConfig(data, config) {
  return post(`/c/pc/communityTelConsultService/getConfig`, data, config);
}
// 服务设置-快速开药-编辑社区电话咨询开关配置
export function communityTelConsultServiceUpdateConfig(data, config) {
  return post(`/c/pc/communityTelConsultService/updateConfig`, data, config);
}
// 服务设置-快速开药-批量更新医生电话咨询显示状态
export function communityTelConsultServiceBatchUpdatePrescribeConsultServiceStatus(data, config) {
  return post(`/c/pc/communityTelConsultService/batchUpdateConsultServiceStatus`, data, config);
}
// 服务设置-图文咨询-电话咨询管理列表-导出
export function communityTelConsultServiceExport(data, config) {
  return postExFile(`/c/pc/communityTelConsultService/export`, data, config);
}
// 服务记录-咨询单管理-退款审核-分页查询列表
export function communityConsultServiceFindRefundAuditPage(data, config) {
  return post(`/c/pc/communityConsultService/findRefundAuditPage`, data, config);
}
// 服务记录-咨询单管理-退款审核-审核
export function communityConsultServiceRefundAudit(data, config) {
  return post(`/c/pc/communityConsultService/refundAudit`, data, config);
}
// 服务记录-咨询单管理-退款审核-获取医生用户联系方式
export function communityConsultServiceGetPhones(data, config) {
  return post(`/c/pc/communityConsultService/getPhones`, data, config);
}
// 服务记录-咨询单管理-列表
export function communityServicePageList(data, config) {
  return post(`/c/pc/communityService/pageList`, data, config);
}
// 服务记录-咨询单管理-列表
export function communityServicePageListExport(data, config) {
  return postExFile(`/c/pc/communityService/pageListExport`, data, config);
}
// 服务记录-咨询单管理-详情-购药
export function communityServiceGetDrugList(data, config) {
  return post(`/c/pc/communityService/getDrugList`, data, config);
}
// 服务记录-咨询单管理-详情-互动记录
export function communityServiceGetInteractiveRecord(data, config) {
  return post(`/c/pc/communityService/getInteractiveRecord`, data, config);
}
// 服务记录-咨询单管理-详情-处方
export function communityServiceGetPrescriptionList(data, config) {
  return post(`/c/pc/communityService/getPrescriptionList`, data, config);
}
// 服务记录-咨询单管理-详情-退款
export function communityServiceGetRefund(data, config) {
  return post(`/c/pc/communityService/getRefund`, data, config);
}
// 服务设置-快捷处方服务批量添加模版校验
export function batchDistributeTemplate2DoctorCheck(data, config) {
  return post(`/c/pc/prescription/template/batchDistributeTemplate2DoctorCheck`, data, config);
}
// 服务设置-快捷处方服务编辑模版校验
export function saveDoctorTemplateCheck(data, config) {
  return post(`/c/pc/prescription/template/saveDoctorTemplateCheck`, data, config);
}
// 服务设置-处方模板分发医生列表
export function TemplateDoctorcopyDetailPage(data, config) {
  return post(`/c/pc/prescription/template/copyDetailPage`, data, config);
}
// 服务设置-处方模板分发医生
export function copyDoctorTemplate(data, config) {
  return post(`/c/pc/prescription/template/copyDoctorTemplate`, data, config);
}
// 服务设置-处方模板分发医生校验
export function copyDoctorTemplateCheck(data, config) {
  return post(`/c/pc/prescription/template/copyDoctorTemplateCheck`, data, config);
}
// 服务设置-处方模板批量分发医生
export function batchCopyTemplate2Doctor(data, config) {
  return post(`/c/pc/prescription/template/batchCopyTemplate2Doctor`, data, config);
}
// 服务设置-处方模板批量分发医生校验
export function batchCopyTemplate2DoctorCheck(data, config) {
  return post(`/c/pc/prescription/template/batchCopyTemplate2DoctorCheck`, data, config);
}
// 服务设置-分发医生列表
export function copyPageDoctorList(data, config) {
  return post(`/c/pc/prescription/template/copyPageDoctor`, data, config);
}
// 服务设置-赠药服务-服务记录列表
export function freeMedicinePageConsult(data, config) {
  return post(`/c/pc/freeMedicineConsult/pageConsult`, data, config);
}
// 服务设置-赠药服务-导出服务记录列表
export function freeMedicineConsultExport(data, config) {
  return postExFile(`/c/pc/freeMedicineConsult/exportConsult`, data, config);
}
//门店管理 新增/修改
export function newcommunityShopInfoSave(data, config) {
  return post(`/c/pc/community/shop/save`, data, config);
}
//门店管理 详情
export function newcommunityShopInfoDetail(data, config) {
  return post(`/c/pc/community/shop/detail`, data, config);
}
//门店管理 KAIGUAN
export function newcommunityShopInfogetConfig(data, config) {
  return post(`/c/pc/community/shop/getConfig`, data, config);
}
export function newcommunityShopInfoupdateConfig(data, config) {
  return post(`/c/pc/community/shop/updateConfig`, data, config);
}
// 查询图文咨询状态列表
export function communityConsultServiceFindConsultStatusList(data, config) {
  return get(`/c/pc/communityConsultService/findConsultStatusList`, data, config);
}
// 分页查询社区图文咨询记录询管理列表
export function communityConsultServicePageRecordList(data, config) {
  return post(`/c/pc/communityConsultService/pageRecordList`, data, config);
}
// 查询电话咨询状态列表
export function communityTelConsultServiceFindConsultStatusList(data, config) {
  return get(`/c/pc/communityTelConsultService/findConsultStatusList`, data, config);
}
// 分页查询社区电话咨询记录询管理列表
export function communityTelConsultServicePageRecordList(data, config) {
  return post(`/c/pc/communityTelConsultService/pageRecordList`, data, config);
}
// 查询快速开药状态列表
export function communityPrescribeConsultServiceFindConsultStatusList(data, config) {
  return get(`/c/pc/communityPrescribeConsultService/findConsultStatusList`, data, config);
}
// 分页查询社区快速开药记录询管理服务记录列表
export function communityPrescribeConsultServicePageRecordList(data, config) {
  return post(`/c/pc/communityPrescribeConsultService/pageRecordList`, data, config);
}
// 图文咨询咨询记录导出
export function communityConsultServicePageListExport(data, config) {
  return postExFile(`/c/pc/communityConsultService/pageListExport`, data, config);
}
// 电话咨询咨询记录导出
export function communityTelConsultServicePageListExport(data, config) {
  return postExFile(`/c/pc/communityTelConsultService/pageListExport`, data, config);
}
// 快速开药咨询记录导出
export function communityPrescribeConsultServicePageListExport(data, config) {
  return postExFile(`/c/pc/communityPrescribeConsultService/pageListExport`, data, config);
}
// 咨询记录-分页查询咨询记录列表
export function consultRecordPageList(data, config) {
  return post(`/c/pc/saleRecord/consultRecord/pageList`, data, config);
}
// 面诊记录-分页查询面诊记录列表
export function diagnosisRecordPageList(data, config) {
  return post(`/c/pc/saleRecord/diagnosisRecord/pageList`, data, config);
}
// 面诊记录-分页查询面诊记录列表
export function goodsRecordPageList(data, config) {
  return post(`/c/pc/saleRecord/goodsRecord/pageList`, data, config);
}